var _g, _g2, _rect, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_615_3539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 13.8095,
    width: 22,
    height: 3.66667,
    rx: 1.83333,
    fill: "url(#paint0_linear_615_3539)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 14.0595,
    width: 21.5,
    height: 3.16667,
    rx: 1.58333,
    stroke: "url(#paint1_linear_615_3539)",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_615_3539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 20.8286,
    width: 22,
    height: 3.66667,
    rx: 1.83333,
    fill: "url(#paint2_linear_615_3539)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 21.0786,
    width: 21.5,
    height: 3.16667,
    rx: 1.58333,
    stroke: "url(#paint3_linear_615_3539)",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 7,
    width: 16.7619,
    height: 3.66667,
    rx: 1.83333,
    fill: "#2EADD4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.666,
    cy: 8.83333,
    r: 1.83333,
    fill: "#2EADD4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_615_3539",
    x: 1.5,
    y: 9.80949,
    width: 30,
    height: 11.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_615_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_615_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_615_3539",
    x: 1.5,
    y: 16.8286,
    width: 30,
    height: 11.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_615_3539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_615_3539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_615_3539",
    x1: 22.7857,
    y1: 15.6428,
    x2: 2.475,
    y2: 23.4214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_615_3539",
    x1: 7.59524,
    y1: 13.0238,
    x2: 9.16667,
    y2: 17.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_615_3539",
    x1: 22.7857,
    y1: 22.6619,
    x2: 2.475,
    y2: 30.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_615_3539",
    x1: 7.59524,
    y1: 20.0429,
    x2: 9.16667,
    y2: 24.4952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.5490bc5f1fe0cdd6d80c2c9e3af17251.svg";
export { ForwardRef as ReactComponent };